import { makeStyles, createStyles } from '@material-ui/core/styles';
import theme from 'styles/theme';

const useStyles = makeStyles(() =>
  createStyles({
    box: {
      width: '100vw',
    },
    boxFooter: {
      backgroundColor: '#FFFFFF',
      height: 100,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      '& .MuiLink-underlineHover': {
        textDecoration: 'none',
        cursor: 'pointer',
        color: theme.palette.grey[100],
      },
    },
    footerLogo: {
      backgroundColor: '#FFFFFF',
    },
    logo: {
      height: 30,
      backgroundColor: '#FFFFFF',
    },
    version: {
      position: 'absolute',
      bottom: 0,
      right: 10,
    },
    boxCopy: {
      backgroundColor: '#F8F8FC',
      height: 48,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    copyright: {
      fontSize: 12,
      color: '#7780A0',
    },
    copyContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    copyContainerMobile: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      paddingTop: 20,
      paddingBottom: 20,
    },
    boxItem: {
      marginRight: 25,

      '& a': {
        fontSize: 12,
        color: '#7780A0',
        marginRight: 10,
        textDecoration: 'none',
      },
    },
    linkCopy: {
      fontSize: 12,
      color: '#7780A0',
      marginRight: 10,
    },
    selectEmpty: {
      backgroundColor: 'transparent',
      fontSize: '12px',
      color: '#7780a0',
      '&&&:before': {
        borderBottom: 'none',
        margin: '0',
        padding: '0',
      },
      '&&&:after': {
        borderBottom: 'none',
        margin: '0',
        padding: '0',
      },
      '& .MuiSelect-select:focus': {
        background: 'transparent',
      },
    },
    footerTop: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      position: 'relative',

      '& .MuiTypography-body2': {
        position: 'absolute',
        top: '33%',
        left: '30%',
      },

      '& div:first-child': {
        width: 170,
        height: 53,
        backgroundColor: theme.palette.grey[100],
      },

      '& a': {
        color: theme.palette.grey[100],
        textDecoration: 'none',
        '& + a': {
          marginLeft: theme.spacing(5),
        },
      },

      '& svg': {
        color: theme.palette.primary.main,
        backgroundColor: '#F2F0FE',
        height: 30,
        width: 30,
        padding: 5,
        borderRadius: 12,
      },

      '& button': {
        '& + button': {
          marginLeft: 10,
        },
      },
    },
  }),
);

export default useStyles;
